import React, { useState } from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch, FormControlLabel } from '@mui/material';

const initialUsers = [
  { id: 1, name: 'John Doe', role: 'Admin', canDeploy: true, canRollback: true, canModifySettings: true },
  { id: 2, name: 'Jane Smith', role: 'Developer', canDeploy: true, canRollback: false, canModifySettings: false },
  { id: 3, name: 'Bob Johnson', role: 'QA', canDeploy: false, canRollback: false, canModifySettings: false },
];

const AccessControls = () => {
  const [users, setUsers] = useState(initialUsers);

  const handleToggle = (userId, permission) => {
    setUsers(users.map(user => 
      user.id === userId ? { ...user, [permission]: !user[permission] } : user
    ));
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Access Controls</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Can Deploy</TableCell>
              <TableCell>Can Rollback</TableCell>
              <TableCell>Can Modify Settings</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={user.canDeploy}
                        onChange={() => handleToggle(user.id, 'canDeploy')}
                        color="primary"
                      />
                    }
                    label=""
                  />
                </TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={user.canRollback}
                        onChange={() => handleToggle(user.id, 'canRollback')}
                        color="primary"
                      />
                    }
                    label=""
                  />
                </TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={user.canModifySettings}
                        onChange={() => handleToggle(user.id, 'canModifySettings')}
                        color="primary"
                      />
                    }
                    label=""
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default AccessControls;
